import * as Sentry from "@sentry/react";

const dsn = import.meta.env.VITE_SENTRY_DSN as string | undefined;
const isProduction = import.meta.env.PROD;

let initialized = false;

export function isBrowserEphiVendorApproved(vendor: string): boolean {
  const parse = (value: string | undefined) =>
    new Set((value ?? "").split(",").map((item) => item.trim().toLowerCase()).filter(Boolean));
  const eligible = parse(import.meta.env.VITE_HIPAA_ELIGIBLE_VENDORS as string | undefined);
  const baaApproved = parse(import.meta.env.VITE_HIPAA_BAA_APPROVED_VENDORS as string | undefined);
  return eligible.has(vendor) && baaApproved.has(vendor);
}

export function initSentry(): void {
  if (initialized || !dsn) return;
  if (isProduction && !isBrowserEphiVendorApproved("sentry")) return;
  initialized = true;
  Sentry.init({
    dsn,
    environment: isProduction ? "production" : "development",
    enabled: isProduction,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 0.1,
    sendDefaultPii: false,
    beforeSend(event) {
      if (event.user) event.user = { id: event.user.id };
      if (event.request?.headers) {
        delete (event.request.headers as Record<string, unknown>).Authorization;
        delete (event.request.headers as Record<string, unknown>).Cookie;
      }
      return event;
    },
  });
}

export function setSentryUser(userId: string | number | null | undefined): void {
  if (!initialized) return;
  if (userId == null) Sentry.setUser(null);
  else Sentry.setUser({ id: String(userId) });
}

export function captureClientError(err: unknown, context?: Record<string, unknown>): void {
  if (!initialized) {
    console.error("[client error]", err, context);
    return;
  }
  Sentry.withScope((scope) => {
    if (context) scope.setExtras(context);
    Sentry.captureException(err);
  });
}

export { Sentry };
